import React from "react";
import ReactDOM from "react-dom";
import {
  Switch,
  Route,
  BrowserRouter as Router,
  Redirect,
} from "react-router-dom";
import Root from "./root";

// Pages
import Login from "./pages/Auth/Login";
import Register from "./pages/Auth/Register";
import ResetPassword from "./pages/Auth/ResetPassword";
import UpdatePassword from "./pages/Auth/UpdatePassword";
import AllComponents from "./AllComponents";
// import Dashboard from "./pages/Dashboard";
// import Customers from "./pages/Customers";
// import Intents from "./pages/Intents";
// import SkillActivations from "./pages/SkillActivations";
// import MessageFromLastHour from "./pages/MessageFromLastHour";
import Actions from "./pages/Actions";

ReactDOM.render(
  <Root>
    <Router>
      <Switch>
        <Redirect from="/" to="/login" exact />
        <Route path="/login" component={Login} />
        <Route path="/register" component={Register} />
        <Route path="/apps" component={Actions} />
        <Route path="/reset-password" component={ResetPassword} />
        <Route path="/update-password" component={UpdatePassword} />
        <Route path="/dashboard" component={AllComponents} />
        {/* <Route path="/dashboard" component={Dashboard} />
        <Route path="/customers" component={Customers} />
        <Route path="/intents" component={Intents} />
        <Route path="/skill-activations" component={SkillActivations} />
        <Route path="/message-from-last-hour" component={MessageFromLastHour} /> */}
      </Switch>
    </Router>
  </Root>,
  document.getElementById("root")
);
